import type from './SupportingDocumentToDo.type';
import { Page_Size as PageSize } from '../../../../../Components/helper';

const initialState = {
  supportingDocumentTodoListData: [],
  supportingDocumentTodoListTotalCount: 0,
  currentRequestId: null,
  supportingDocumentTodoFilterValues: {
    searchText: '',
    pageIndex: 1,
    pageSize: PageSize,
    sortOrder: '',
    sortPropertyName: '',
    expiry: '',
    loading: false,
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
  },
};

const supportingDocumentTodoListReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case type.SET_SUPPORTING_DOCUMENT_TODO_LIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      return {
        ...state,
        supportingDocumentTodoListData: action.payload.isScrolled
          ? [...(state?.supportingDocumentTodoListData || []), ...(action?.payload?.data || [])]
          : action?.payload?.data || [],
        supportingDocumentTodoListTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
        supportingDocumentTodoFilterValues: {
          ...state.supportingDocumentTodoFilterValues,
          loading: false,
        },
      };
    }
    case type.SET_FILTER_SORT_DATA:
      return {
        ...state,
        supportingDocumentTodoFilterValues: {
          ...state.supportingDocumentTodoFilterValues,
          ...action.payload,
        },
      };
    case type.BULK_DELETE_SUPPORTING_DOCUMENTS: {
      const { deletedIds } = action.payload;
      const remainingDocuments = state.supportingDocumentTodoListData.filter((document) => !deletedIds.includes(document._id));
      return {
        ...state,
        supportingDocumentTodoListData: remainingDocuments,
        supportingDocumentTodoListTotalCount: state.supportingDocumentTodoListTotalCount - deletedIds.length,
      };
    }
    default:
      return state;
  }
};

export default supportingDocumentTodoListReducer;
